export default "__VITE_ASSET__DOmQLB0v__"